import axios from 'axios'

import { tokenStorage } from './tokenStorage'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  timeout: 60000,
})
// NOTE: no global ``Content-Type`` on purpose. Axios sets ``application/json``
// itself for object bodies, while a fixed JSON content type would make it turn
// every ``FormData`` into JSON (dropping the attached files).

let onUnauthorized = null

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler
}

http.interceptors.request.use((config) => {
  const token = tokenStorage.get()
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && onUnauthorized) {
      onUnauthorized()
    }
    return Promise.reject(error)
  },
)

export default http
